import { render, staticRenderFns } from "./CameraMonitor.vue?vue&type=template&id=54c8b5e3&scoped=true&"
import script from "./CameraMonitor.vue?vue&type=script&lang=js&"
export * from "./CameraMonitor.vue?vue&type=script&lang=js&"
import style0 from "./CameraMonitor.vue?vue&type=style&index=0&id=54c8b5e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c8b5e3",
  null
  
)

export default component.exports